// extracted by mini-css-extract-plugin
module.exports = {"details":"event-details_details__2fR4j"};